export default __webpack_public_path__ + "i18n/translations/translation-nl.20c7c2dd.json";